import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import type { components } from '@/api/types'

/** Generált típus a backend OpenAPI-ból (DEC-BILLING-007). */
export type PlanSetting = components['schemas']['PlanSetting']

export const PLAN_SETTINGS_QUERY_KEY = ['admin', 'billing', 'settings'] as const

/** `GET /admin/billing/settings` — az effektív (override utáni) sáv-katalógus. */
export function usePlanSettings() {
  return useQuery({
    queryKey: PLAN_SETTINGS_QUERY_KEY,
    queryFn: async (): Promise<PlanSetting[]> => {
      const { data, error } = await apiClient.GET('/admin/billing/settings')
      if (error) throw error
      return data?.data ?? []
    },
  })
}

/** `PUT /admin/billing/settings` — override-ok upsertje (key → érték). */
export function useUpdatePlanSettings() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (settings: Record<string, unknown>): Promise<PlanSetting[]> => {
      const { data, error } = await apiClient.PUT('/admin/billing/settings', {
        body: { settings },
      })
      if (error) throw error
      return data?.data ?? []
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: PLAN_SETTINGS_QUERY_KEY })
    },
  })
}
